var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 30,
    viewBox: "0 0 46 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 30,
    fill: "#F5F5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 29,
    rx: 4.5,
    fill: "white",
    stroke: "#9876A4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8541 10.1711L20.8498 19.5414H18.4255L20.43 10.1711H22.8541ZM33.0528 16.2216L34.3287 12.7029L35.063 16.2216H33.0528ZM35.7584 19.5414H38L36.0417 10.1711H33.974C33.508 10.1711 33.1152 10.4413 32.9413 10.858L29.3039 19.5414H31.8498L32.3552 18.142H35.4649L35.7584 19.5414ZM29.4302 16.4823C29.4407 14.0094 26.0116 13.8724 26.0345 12.7674C26.0419 12.4317 26.3622 12.074 27.0624 11.9826C27.4095 11.9379 28.3673 11.9016 29.4531 12.4019L29.8778 10.4141C29.2947 10.2032 28.5442 10 27.6103 10C25.2139 10 23.528 11.2729 23.5146 13.0972C23.4992 14.4462 24.7188 15.1984 25.6358 15.6477C26.5812 16.107 26.898 16.4014 26.8933 16.8117C26.8868 17.4404 26.1395 17.7188 25.4436 17.7294C24.2242 17.7483 23.5173 17.3997 22.954 17.1371L22.5139 19.1913C23.0812 19.451 24.1266 19.6769 25.209 19.6885C27.7568 19.6885 29.4226 18.4305 29.4302 16.4823ZM19.3901 10.1711L15.4623 19.5414H12.9002L10.9672 12.0633C10.85 11.6034 10.7478 11.4344 10.3914 11.2401C9.80847 10.9235 8.84617 10.6274 8 10.4432L8.05733 10.1711H12.1822C12.7076 10.1711 13.1803 10.5208 13.3006 11.1261L14.3217 16.5487L16.8434 10.1711H19.3901Z",
    fill: "#1434CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.bdb04bb63ff7c99ac160a4f01d4dd9f6.svg";
export { ForwardRef as ReactComponent };